import { c as _c } from "react/compiler-runtime";
import { SelectRole } from "@components/role/select-role";
import { getDisabledRoles } from "@utils/workspace-role-utils";
import { FaroCoreApiConst } from "@stellar/core-api-client";

/**
 *  Renders a dropdown to select company role
 *  TODO: Refactor this component to handle only TableCell fields, as it is no longer used for non-TableCell fields
 *  https://faro01.atlassian.net/browse/ST-2993.
 */
export function SelectCompanyRole(t0) {
  const $ = _c(14);
  const {
    selectedRole,
    onChange,
    variant,
    isRequired: t1,
    shouldAllowAllRolesSelection: t2,
    menuProps,
    isDisabled,
    roles: t3
  } = t0;
  const isRequired = t1 === undefined ? true : t1;
  const shouldAllowAllRolesSelection = t2 === undefined ? false : t2;
  const roles = t3 === undefined ? FaroCoreApiConst.allCompanyRoles : t3;
  let t4;
  if ($[0] !== onChange) {
    t4 = function onSelectRoleChange(role) {
      onChange(role);
    };
    $[0] = onChange;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const onSelectRoleChange = t4;
  let t5;
  if ($[2] !== selectedRole || $[3] !== shouldAllowAllRolesSelection) {
    t5 = shouldAllowAllRolesSelection || !selectedRole ? [] : getDisabledRoles(selectedRole);
    $[2] = selectedRole;
    $[3] = shouldAllowAllRolesSelection;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const disabledRoles = t5;
  let t6;
  if ($[5] !== disabledRoles || $[6] !== isDisabled || $[7] !== isRequired || $[8] !== menuProps || $[9] !== onSelectRoleChange || $[10] !== roles || $[11] !== selectedRole || $[12] !== variant) {
    t6 = <SelectRole label="Workspace role" roles={roles} disabledRoles={disabledRoles} variant={variant} selectedRole={selectedRole} onChange={onSelectRoleChange} link="workspaceRolesHelp" isRequired={isRequired} menuProps={menuProps} isDisabled={isDisabled} />;
    $[5] = disabledRoles;
    $[6] = isDisabled;
    $[7] = isRequired;
    $[8] = menuProps;
    $[9] = onSelectRoleChange;
    $[10] = roles;
    $[11] = selectedRole;
    $[12] = variant;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}